module.exports = __webpack_public_path__ + "static/Panda4-dcfef77c56540be5993385a8f2c554a8.svg";